import profile from '../assets/portfolio-profile.png';
import logo from '../assets/final-logo.jpg';
import profile1 from '../assets/about-profile.jpg';
import react from '../assets/react.png';
import javascript from '../assets/javascript.png';
import html from '../assets/html.png';
import css from '../assets/css.png';
import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import instagram from '../assets/instagram.png';
import mail from '../assets/mail.png';
import github from '../assets/github.png';
import errorImage from '../assets/error-image-final.png';
import portfolio from '../assets/portfolio.png';
import spotify_clone from '../assets/spotify-clone.png';
import hireme from '../assets/hireme.png';
import color_spotter from '../assets/color-spotter.png';
export default {
  profile,
  logo,
  profile1,
  react,
  css,
  html,
  javascript,
  email,
  mobile,
  instagram,
  mail,
  github,
  errorImage,
  color_spotter,
  spotify_clone,
  hireme,
  portfolio,
};
